import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class MetaService {

    frontendUrl = window.location.origin;

    constructor(private _meta: Meta, private _router: Router) { }

    settingUpOgUrl() {
        this._meta.updateTag({ property: 'og:url', content: this.frontendUrl + this._router.url });
    }

    settingUpOgImage(imageUrl: string) {
        this._meta.updateTag({ property: 'og:image', content: (imageUrl) as string });
    }
}
